import { render } from "./profile-desktop.vue?vue&type=template&id=1f3dd114&scoped=true&ts=true"
import script from "./profile-desktop.vue?vue&type=script&lang=ts"
export * from "./profile-desktop.vue?vue&type=script&lang=ts"

import "./profile-desktop.vue?vue&type=style&index=0&id=1f3dd114&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3dd114"]])

export default __exports__